
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M11.907 1.5H6.574c-.55 0-1.078.246-1.467.683a2.49 2.49 0 0 0-.607 1.65c0 .62.219 1.213.607 1.65.39.438.917.684 1.467.684m0 0h3.852c.55 0 1.078.245 1.466.683A2.49 2.49 0 0 1 12.5 8.5c0 .619-.219 1.212-.607 1.65a1.964 1.964 0 0 1-1.467.683M6.574 6.167c-.55 0-1.078.245-1.467.683A2.49 2.49 0 0 0 4.5 8.5c0 .619.219 1.212.607 1.65.39.438.917.683 1.467.683h3.852m0 0c.55 0 1.078.246 1.466.684.39.437.608 1.03.608 1.65a2.49 2.49 0 0 1-.607 1.65 1.964 1.964 0 0 1-1.467.683H4.5","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    